<template>
    <TabWrapper @change="change">
        <Headline>Site</Headline>
        <span class="description">
            Aktivieren bzw. Deaktivieren der kompletten Werbeausspielung für die <b>komplette Seite</b>.
        </span>
        <v-row>
            <v-col>
                <Toggle v-model="siteIsDisabled" @input="updateSiteIsDisabled"
                        label="Werbeausspielung deaktiviert"></Toggle>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <Headline>Sitetypes</Headline>
                <span class="description">
                    Aktivieren bzw. Deaktivieren der kompletten Werbeausspielung auf <b>einzelnen Sitetypes</b>.
                </span>
                <v-row v-for="sitetype in sitetype_copy" :key="sitetype.SitetypeId" no-gutters>
                    <v-col>
                        <Toggle v-model="sitetype.IsDisabled" :hide-details="true"
                                :label="sitetype.Name + ' deaktiviert'"
                                @input="updateDisabledSitetypes(sitetype)"></Toggle>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <Button class="mt-8" @click="submit" :color="ada.pink"
                        :loading="loading">
                    Speichern & Deployen
                </Button>
            </v-col>
        </v-row>
    </TabWrapper>
</template>

<script>
import TabWrapper from "../../EmergencyStop/Tabs/TabWrapper";
import ada from "../../../scss/ada_colors.scss";
import Toggle from "../../../components/buttons/Toggle";
import Headline from "../../../components/Headline";
import Button from "../../../components/buttons/Button";

export default {
    name: "General",
    components: {Button, Headline, Toggle, TabWrapper},
    props: ['loading'],
    data: () => {
        return {
            siteIsDisabled: 0,
            sitetype_copy: null,
            typeIsDisabled: {}, //sitetypes that differ from the store
            ada
        }
    },
    mounted() {
        if (this.siteDetails) {
            this.init();
            this.$emit('activeComponent', this);
        }
    },
    computed: {
        siteDetails() {
            return this.$store.state.emergency.siteDetails;
        },
        sitetypes() {
            return this.siteDetails ? this.siteDetails.Types : [];
        },
        activeTab() {
            return this.$store.state.emergency.activeTab;
        }
    },
    methods: {
        init() {
            this.siteIsDisabled = this.siteDetails.Site.IsDisabled;
            this.sitetype_copy = JSON.parse(JSON.stringify(this.sitetypes));
        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.$store.state.emergency.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            }
        },
        dataChanged() {
            this.typeIsDisabled = {};
            let changed = false;
            if (this.siteIsDisabled !== this.siteDetails.Site.IsDisabled) {
                changed = true;
            }
            if (!changed) {
                for (let i = 0; i < this.sitetype_copy.length; i++) {
                    if (this.sitetype_copy[i].IsDisabled !== this.sitetypes[i].IsDisabled) {
                        if (!changed) changed = true;
                        if (this.sitetype_copy[i].IsDisabled === 1) {
                            this.typeIsDisabled[this.sitetype_copy[i].SitetypeId] = this.sitetype_copy[i].IsDisabled;
                        }
                    }
                }
            }
            return changed;
        },
        updateDisabledSitetypes(sitetype) {
            this.$store.commit('emergency/updateDisabledSitetypes', sitetype);
        },
        updateSiteIsDisabled() {
            this.$store.commit('emergency/updateSiteIsDisabled', this.siteIsDisabled);
        }
    }
    ,
    watch: {
        siteDetails() {
            if (this.siteDetails) {
                this.init();
            }
        },
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>